// extracted by mini-css-extract-plugin
export default {"home":"home__s0ssE","hdrbgfr":"hdrbgfr__97Wzm","cardouter":"cardouter__Q4248","cardfr":"cardfr__9XTRv","clfl":"clfl__sQQt5","clfr":"clfr__EyNod","inprod":"inprod__tlWTy"};